<template>
  <div class="container-fluid" style="padding: 0" >

    <!-- Header -->
    <div class="row" id="header-container">
      <div id="header-fader" />
      <img id="header-image" src="@/assets/images/frontpage_header.jpg"/>
    </div>

    <!-- Header Content -->
    <div class="row justify-content-center" id="header-content">
      <p class="col-12" id="header-title">{{ t('home-header') }}</p>

      <!-- Force next columns to break to new line -->
      <div class="w-100"></div>

      <div class="col-8 col-md-3 col-xl-2">
        <a :href="appstoreLink()" target="_blank" class="linkbadgeWrapper" @click="downloadBadgeClick">
          <img class="linkbadge" src="@/assets/images/appstore_badge.svg" />
        </a>
      </div>

      <div class="col-8 col-md-3 col-xl-2">
        <a :href="googlePlayLink()" target="_blank" class="linkbadgeWrapper" @click="downloadBadgeClick">
          <img class="linkbadge" src="@/assets/images/playstore_badge.svg" />
        </a>
      </div>

      <!-- Force next columns to break to new line -->
      <div class="w-100"></div>

      <p class="col-11 col-md-8 col-xl-5" id="header-text">{{ t('home-subheader') }}</p>
    </div>

    <!-- Top Feed -->
    <p v-if="newFeed.items && newFeed.items.length > 0" class="feed-header">Top-Uploads</p>
    <div v-if="newFeed.items && newFeed.items.length > 0" class="row justify-content-center feed">
      <div class="col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-10">
        <feed-component :items="newFeed.items" />
      </div>
    </div>

  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref } from 'vue'
import { fetchReleasedItems } from '@/services/Api'
import { FeedState } from '@/dto/FeedState'
import FeedComponent from '@/views/components/feed/FeedComponent.vue'
import HFeedComponent from '@/views/components/feed/HFeedComponent.vue'
import { LoadingState } from '@/dto/enums/LoadingState'
import { logDownloadBadgeClick } from '@/services/EventLogger'
import { useI18n } from 'vue-i18n'
import { createAppstoreLink, createGoogleStoreLink } from '@/services/DynamicLink'

export default defineComponent({
  components: {
    FeedComponent
  },

  setup() {
    const childComponentRef = ref<InstanceType<typeof HFeedComponent>>()
    const newFeed = reactive(new FeedState())

    const { t } = useI18n({
      inheritLocale: true,
      scope: 'locale'
    })

    return { newFeed, LoadingState, t, childComponentRef }
  },

  methods: {
    downloadBadgeClick() {
      logDownloadBadgeClick()
    },

    appstoreLink(): string {
      return createAppstoreLink()
    },

    googlePlayLink(): string {
      return createGoogleStoreLink()
    }
  },

  mounted() {
    fetchReleasedItems().then(response => {
      this.newFeed.items = response.items
      this.newFeed.loadingState = LoadingState.Loaded
    })
  }
})
</script>

<style lang="sass" scoped>
#header-container
  position: relative
  min-height: 10vh
  margin: 0

#header-fader
  width: 100%
  height: 100%
  position: absolute
  padding: 0
  background: linear-gradient(0deg, $color_background, #00000000)

#header-content
  position: relative
  margin: -8% 0 0 0

#header-title
  font-size: 2em
  font-weight: 500
  text-align: center
  @media (max-width: $breakpoint-md)
    font-size: 1.6em

#header-text
  font-size: 1.2em
  margin-top: 24px
  text-align: center
  @media (max-width: $breakpoint-md)
    font-size: 1.1em

.linkbadgeWrapper
  display: block
  width: 100%

.linkbadge
  margin: 6px 0 6px 0
  width: 100%

.feed-header
  margin-top: 40px
  font-size: 1.6em
  font-weight: 500
  text-align: center

#header-image
  width: 100%
  height: 40vh
  object-fit: cover
  padding: 0

  @media (min-width: $breakpoint-md)
    height: 50vh
    @media (min-width: $breakpoint-lg)
      height: 60vh
      @media (min-width: $breakpoint-xl)
        height: 69vh

.feed
  margin: 0
</style>
